<input (input)="onInput($event)" type="text" [disabled]="disabled" class="xfw3-form-control" [value]="value">
